import { render, screen } from '@testing-library/react'
import ResearchPage from './ResearchPage'

describe('ResearchPage', () => {
  test('renders the research content as a standalone page', () => {
    render(<ResearchPage />)

    expect(screen.getByRole('heading', { name: /investigación/i })).toBeTruthy()
    expect(screen.getByRole('link', { name: /volver/i }).getAttribute('href')).toBe('/asociacion')
    expect(screen.getByText(/alteraciones del ciclo menstrual y confinamiento/i)).toBeTruthy()
    expect(screen.getByText(/atención sanitaria en menopausia y climaterio/i)).toBeTruthy()
    expect(screen.getAllByRole('link', { name: /leer artículo/i })).toHaveLength(2)
  })
})
